import { proxy } from "valtio";

export class Prefs {
    public state = proxy({
        pointSize: { min: 1, max: 10, step: 1, value: [4] as [number] },
        quality: "medium" as "low" | "medium" | "high",
        units: "metric" as "metric" | "imperial",
        volumeExpanded: false,
    });
}
